module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-item-details",
    class: [_vm.product.align == 'left' ? 'align-left' : 'align-right']
  }, [_c('div', {
    staticClass: "product-item-details-header",
    domProps: {
      "innerHTML": _vm._s(_vm.product.name)
    }
  }), _vm._v(" "), (_vm.product.patentPending) ? _c('span', {
    staticClass: "patent-pending-badge"
  }, [_vm._v("PATENT PENDING")]) : _vm._e(), _vm._v(" "), (_vm.product.description) ? _c('div', {
    staticClass: "product-item-details-body"
  }, [(_vm.product.isBeta) ? _c('span', {
    staticClass: "beta-badge"
  }, [_vm._v("BETA")]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.product.description) + "\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.showFeaturesMobile) ? _c('div', {
    staticClass: "attach-item-feature-toggle-mobile",
    on: {
      "click": _vm.toggleFeatures
    }
  }, [(!_vm.showFeaturesMobile) ? _c('span', [_vm._v("Learn more "), _c('i', {
    staticClass: "fa fa-plus-square"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "attach-item-feature-wrapper",
    class: [_vm.showFeaturesMobile ? 'mobile-show' : 'mobile-hide'],
    on: {
      "click": _vm.toggleFeatures
    }
  }, _vm._l((_vm.product.features), function(feature) {
    return _c('div', {
      staticClass: "attach-item-feature",
      domProps: {
        "innerHTML": _vm._s(feature)
      }
    })
  }), 0), _vm._v(" "), _c('a', {
    staticClass: "attach-item-request-demo-button",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": function($event) {
        return _vm.clickProductButton(_vm.product)
      }
    }
  }, [_vm._v("Request a demo")]), _vm._v(" "), (_vm.product.learnMore) ? _c('div', {
    staticClass: "learn-more-link",
    class: [_vm.product.align == 'left' ? 'learn-more-left' : 'learn-more-right']
  }, [_vm._v("\n    " + _vm._s(_vm.product.learnMore.text) + "\n    "), _c('a', {
    attrs: {
      "href": _vm.product.learnMore.href
    }
  }, [_vm._v("Learn more "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52a37036"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/AttachProductComponents/ProductDetailsComponent.vue
// module id = 477
// module chunks = 0